import Responsive from '../../scripts/Responsive'

class Animation {

  constructor($refs, data) { 
    this.hoverTl = new TimelineLite({
      onUpdate: this.onUpdate,
      onComplete: this.onComplete
    }); // Hover timeline
    this.clickTl = new TimelineLite({
      onUpdate: this.onUpdate,
      onComplete: this.onComplete
    }); // Click timeline

    this.serviceData = data;
  }

  onUpdate() {
    //console.log("updates");
  }

  onComplete(e) {
    // this references MasterTimeline

    //this.restart();
    //this.pause();
  }

  prepare($refs) {
    // Vsak element, ki se animira ima lahko potem svoj timeline

    // Tle lahko popraviš vrednosti glede na window width - responsive
    var ww = screen.width;
    var boxWidth = document.getElementsByClassName("service")[0].offsetWidth;
    var boxHeight = document.getElementsByClassName("service")[0].offsetHeight;

    var splash = document.getElementById("splash");
    var navigation = document.getElementById("navigation");

    var medium = false;
    var mobile = false;

    // Vrednosti za mobile
    var borderOffset = 0;
    var borderRightOffset = 0;

    var openedBoxY = 245;

    if (ww > 1440) {
      var openedBoxWidth = 1197;
      var openedBoxHeight = 580;
      var openedBoxX = (ww - openedBoxWidth) / 2;
    } else if (ww > 1210 && ww < 1440) {
      var openedBoxWidth = 1197;
      var openedBoxHeight = 700;
      var openedBoxX = (ww - openedBoxWidth) / 2;
      borderOffset = 115;
      medium = true;

    } else if (ww <= 1210 && ww > 800) {
      var openedBoxWidth = 800;
      var openedBoxHeight = 680;
      var openedBoxX = (ww - openedBoxWidth) / 2;
      openedBoxY = 245;
      medium = true;
    } else  {
      var openedBoxWidth = ww;
      var openedBoxHeight = document.getElementsByClassName("service").length * 100;
      borderOffset = 60; //padding-left zaradi thumb boxov
      var openedBoxX = 0;
      borderRightOffset = -25;
      mobile = true;
    }

    var targetScroll = splash.offsetHeight - navigation.offsetHeight;

    var lineTimeline = new TimelineLite({
      onComplete: this.onLineAnimationComplete
    });
    lineTimeline
      .to($refs.rect, 0.3, {
        width: 5
      }, "borderAnimation") // Move arrow rectangle inside arrow
      .to($refs.bg, 1.3, {
        scale: 1.08
      }, "borderAnimation");

    // Build hover timeline
    this.hoverTl
      .add(lineTimeline)
      .timeScale(1)
      .pause();

    var boxTimeline = new TimelineLite({
      onComplete: this.onBoxAnimationComplete
    });
    boxTimeline
      .set($refs.rect, {
        display: "none"
      })
      .to($refs.borderRight, 0.8, {
        height: boxHeight - 40,
        right: borderRightOffset,
        ease: Power1.easeOut
      }, "borderAnimation")
      .to($refs.borderBottom, 0.8, {
        width: boxWidth - 40 - borderOffset,
        right: borderRightOffset,
        ease: Power1.easeOut
      }, "borderAnimation")
      .to([$refs.bg, $refs.title, $refs.overlay], 0.8, {
        opacity: 0
      }, "borderAnimation")
      .to($refs.parent, 1.2, {
        width: openedBoxWidth,
        left: openedBoxX,
        top: openedBoxY,
        height: openedBoxHeight
      }, "extendWidth")
      .add(function () {
      }, "extendWidth") // Scroll to start of opened service
      .to($refs.borderBottom, 1.2, {
        width: (openedBoxWidth - 50 - borderOffset)
      }, "extendWidth")
      .to($refs.borderRight, 1.2, {
        height: openedBoxHeight - 50
      }, "extendWidth")
      .to($refs.borderTop, 1.2, {
        width: openedBoxWidth - 50 - borderOffset
      }, "extendWidth")
      .to($refs.borderLeft, 1.2, {
        height: openedBoxHeight - 50
      }, "extendWidth")
      .set($refs.parent, {
        className: "+=opened"
      })
      .add(() => {
        if (mobile) {
          TweenMax.set(document.getElementById("storitve"), {
            height: 980
          });
          window.dispatchEvent(new Event('resize'));
        } else if (medium)  {
          TweenMax.set(document.getElementById("storitve"), {
            height: 1000
          });
          window.dispatchEvent(new CustomEvent('resize'));
        } else {
        }

        TweenMax.to(document.querySelector("#storitve .bg2"), 0.4, {
          height: "20%"
        });

        TweenMax.to(document.querySelector("#storitve .bg4"), 0.4, {
          height: "65%"
        });

        TweenMax.to(document.querySelector("#storitve .bg5"), 0.4, {
          height: "80%",
          backgroundColor: "white"
        });

        TweenMax.set(document.getElementsByClassName("service"), {
          display: "none"
        })

        TweenMax.set(document.querySelector("#strojni-park .inner"), {
          className: "+=moveup"
        })

      });

    this.clickTl
      .add(boxTimeline)
      .timeScale(1)
      .pause();
  }

  onLineAnimationComplete() {
    //console.log("complete line animation");
  }

  onBoxAnimationComplete() {
    window.EventBus.$emit('boxAnimationComplete', "emitted complete event");
  }

  onClick(data) {
    this.clickTl.play();
  }

  onHover() {
    this.hoverTl.timeScale(1).play();
  }

  pause()  {
    this.hoverTl.pause();
  }

  reverse() {
    this.hoverTl
      .timeScale(2).reverse();
  }
}

export default Animation;



// WEBPACK FOOTER //
// ./src/components/Services/Animation.js